import { user_coin_asset } from "./UserCoinAsset";
import { user_coin_asset_list } from "./UserCoinAssetList";
import { user_deposit_address } from "./UserDepositAddress";
import { user_deposit_record } from "./UserDepositRecord";
import { user_deposit_record_list } from "./UserDepositRecordList";
import { user_transfer } from "./UserTransfer";
import { user_transfer_record } from "./UserTransferRecord";
import { user_transfer_record_list } from "./UserTransferRecordList";
import { user_withdraw_to_record } from "./UserWithdrawRecord";
import { user_withdraw_to_record_list } from "./UserWithdrawRecordList";
import { user_withdraw_to_cwallet } from "./UserWithdrawToCwallet";
import { user_withdraw_to_network } from "./UserWithdrawToNetwork";
export const codeMap: { [key: string]: any } = {
  user_coin_asset,
  user_coin_asset_list,
  user_deposit_address,
  user_deposit_record,
  user_deposit_record_list,
  user_withdraw_to_network,
  user_withdraw_to_cwallet,
  user_withdraw_to_record,
  user_withdraw_to_record_list,
  user_transfer,
  user_transfer_record,
  user_transfer_record_list,
};
